import { Link } from 'react-router-dom';
import AppLogo from 'shared_components/AppLogo';
import Text from 'shared_components/Text';
import styles from './styles.module.scss';

const Fallback = () => {
  return (
    <div className={styles.ErrorBoundary}>
      <AppLogo />
      <Text className={styles.ErrorBoundary__title}>
        Oops... Something went wrong :(
      </Text>
      <Text className={styles.ErrorBoundary__description}>
        Please consider&nbsp;
        <a className={styles.link} href="mailto:support@kolectiv.gg">
          reporting
        </a>
        &nbsp;more details on this crash to allow Kolectiv to take swift action
        and improve the platform.
      </Text>
    </div>
  );
};

export default Fallback;
